import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const summary = {
  totalOrders: param => {
    const url = api.summary.totalOrders + serializeQueryParams(param)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  logisticOrders: param => {
    const url = api.summary.logisticOrders + serializeQueryParams(param)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  expenses: param => {
    const url = api.summary.expenses + serializeQueryParams(param)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  paymentReports: params => {
    const url = api.summary.paymentReports + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  paymentReportsDownload: params => {
    const url = api.summary.paymentReportsDownload + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default summary
